"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TracingEvaluator = void 0;
const BasicAnalysisEngine_1 = require("../engines/BasicAnalysisEngine");
class TracingEvaluator {
    basicEngine;
    constructor(basicEngine = new BasicAnalysisEngine_1.BasicAnalysisEngine()) {
        this.basicEngine = basicEngine;
    }
    async evaluate(submission, activity) {
        const targetText = String(activity.config.targetText ?? '');
        const strokes = submission.strokes ?? [];
        const analysis = await this.basicEngine.analyzeCraftsmanship(strokes, targetText) ?? {
            score: 0,
            feedback: 'No tracing data available.',
            suggestions: [],
            details: {},
        };
        return {
            score: analysis.score,
            maxScore: 100,
            feedback: analysis.feedback,
            breakdown: [
                {
                    name: 'Trace Accuracy',
                    score: analysis.score,
                    maxScore: 100,
                    feedback: analysis.suggestions[0] ?? 'Tracing analysis complete',
                },
            ],
            skills: [{ key: `letter:${targetText.toLowerCase()}`, label: `Letter ${targetText.toUpperCase()}` }],
            label: 'Neatness Score',
        };
    }
}
exports.TracingEvaluator = TracingEvaluator;
